import PushNotificationService from '@/services/PushNotificationService';
import * as types from './mutation-types';

const ent = require('ent');

const pushNotificationService = new PushNotificationService();

export const fetchAllUsersWithFcmToken = ({ commit }, data) => new Promise(
  (resolve, reject) => {
    console.log(data);
    pushNotificationService
      .getAllUsersWithFcmToken(data)
      .then((response) => {
        commit(types.USER, response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  },
);

export const fetchAllPushNotifications = ({ commit }, data) => new Promise(
  (resolve, reject) => {
    pushNotificationService
      .getAllPushNotifications(data)
      .then((response) => {
        commit(types.PUSH_NOTIFICATIONS, response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  },
);
